
import {setLStore, getLStore, removeLStore, IsValid, IsBottom, getBefore, getHind, getSStore, format } from '@js/public/mUtils'
import InlineLoading from 'vux/src/components/inline-loading/index.vue'
import Divider from 'vux/src/components/divider/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'

import {NoScroll, Scroll} from '@js/public/animation'
export default {
name: 'all',
components: {
InlineLoading, Divider, XButton
},
props: ['scroll'],
data () {
return {
pageNum: 8, // 每页内容数
canScroll: true, // 能否滚动加载更多
scrollLoading: true, // 加载中loading
fundItems: [], // 基金列表
}
},
activated () {
this.eventBus.$emit('changeTab', 0)
},
created () {
this.$emit('changeTab', 0)
this.getHotSell().then(res => {

if (IsValid(getSStore('token'))) { // 已登录
console.log('已登录')

}
})
},
mounted () {
window.onscroll = null
},
methods: {
initScroll () {
},
myFormat (type, val) {
if (type === '00.00%') {
if (val > 0) {
return '+' + format(type, val)
}
}
return format(type, val)
},
/*获取热销基金*/
getHotSell () {
return this.$http.post('/fund/list/choiceness', {}).then(res => {
for (var i = 0; i < res.body.list.length; i++ ) {
res.body.list[i].interested = false
}
this.fundItems = res.body.list
this.scrollLoading = false
return res
})
},
/*获取字符前两位*/
getMyBefore (code) {
return getBefore(code)
},
getMyHind (code) {
return getHind(code)
},
toProduct (code) {
this.toPage('/productDetail', {fundCode: code})
}
}
}



// WEBPACK FOOTER //
// ./src/components/home/money/choiceness.vue